import { compose, lifecycle, withState } from 'recompose';

const checkScroll = (offset, callback) => {
  let isStuck = false;

  (function check() {
    const scroll = document.documentElement.scrollTop;

    if (!isStuck && scroll > offset) {
      isStuck = true;
      callback(isStuck);
    }
    if (isStuck && scroll <= offset) {
      isStuck = false;
      callback(isStuck);
    }

    requestAnimationFrame(check);
  })();
};

export const withStickyPosition = (offset) =>
  compose(
    withState('isStuck', 'setStuck', false),
    lifecycle({
      componentDidMount() {
        const { setStuck } = this.props;

        checkScroll(offset, setStuck);
      },
    })
  );
